'use strict';
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIssuing$002dBank$0024 from "./app.data.data_point_types$package$-Issuing-Bank$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$() {
  this.aMn = null;
  this.aMA = null;
  this.aMs = null;
  this.aMt = false;
  this.aMy = null;
  this.aMz = false;
  this.aMo = null;
  this.aMp = false;
  this.aMw = null;
  this.aMx = false;
  this.aMu = null;
  this.aMv = false;
  this.aMq = null;
  this.aMr = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ = this;
  this.aMn = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIssuing$002dBank$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$();
  this.aMA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIssuing$002dBank$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$.prototype = $p;
$p.eR = (function() {
  return this.aMn;
});
$p.eO = (function() {
  return this.aMA;
});
$p.b9 = (function() {
  if ((!this.aMt)) {
    this.aMs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aMt = true;
  }
  return this.aMs;
});
$p.b3 = (function() {
  if ((!this.aMz)) {
    this.aMy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aMz = true;
  }
  return this.aMy;
});
$p.aG = (function() {
  if ((!this.aMp)) {
    this.aMo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aMp = true;
  }
  return this.aMo;
});
$p.az = (function() {
  if ((!this.aMx)) {
    this.aMw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aMx = true;
  }
  return this.aMw;
});
$p.aY = (function() {
  if ((!this.aMv)) {
    this.aMu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aMv = true;
  }
  return this.aMu;
});
$p.bN8 = (function() {
  if ((!this.aMr)) {
    this.aMq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Issuing Bank";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aMr = true;
  }
  return this.aMq;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$, "app.data.data_point_types$package$IssuingBankForm$", ({
  G2: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$ };
//# sourceMappingURL=app.data.data_point_types$package$-Issuing-Bank-Form$.js.map
